import { Box, IconButton, styled } from '@mui/material';

export const EmailContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  backgroundColor: theme.palette.grey[100],
  padding: theme.spacing(1.5, 2),
  borderRadius: theme.spacing(1),
  marginTop: theme.spacing(2),
}));

export const EmailText = styled(Box)(({ theme }) => ({
  margin: 0,
  flex: 1,
  fontFamily: 'inherit',
  fontSize: theme.typography.body1.fontSize,
  background: theme.palette.neutral[100],
  overflowWrap: 'anywhere',
  wordBreak: 'break-all',
  minWidth: 0,
}));

export const CopyButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.grey[200],
  '&:hover': {
    backgroundColor: theme.palette.grey[300],
  },
}));
